import React, { Component } from 'react';
import IntlMessages from '../../helpers/IntlMessages';
import moment from 'moment';

import AlertCard from './AlertCard';
import { injectIntl } from 'react-intl';

class OfficeCard extends Component {
  render() {
    const {
      reservation,
      order,
      intl: { messages },
    } = this.props;

    return (
      <div className="item">
        <div className="date">
          <div className="content">
            <span className="day">
              {moment(
                reservation.officeDetails.date,
                'DD/MM/YYYY HH:mm'
              ).format('DD')}
            </span>
            <span className="month">
              {moment(
                reservation.officeDetails.date,
                'DD/MM/YYYY HH:mm'
              ).format('MMM')}
            </span>
          </div>
        </div>
        <div
          className="details"
          onClick={() => {
            this.props.openOffice(reservation);
          }}
        >
          <div
            className="details-content hotel"
            style={{
              backgroundImage: reservation.officeDetails.office.mainPhoto
                ? `url(${reservation.officeDetails.office.mainPhoto})`
                : 'inherit',
            }}
          >
            <div className="gradient">
              <div className="header">
                <div className="img" />
                <div>
                  <span>
                    <IntlMessages id="travel.office_name" />
                  </span>
                  {reservation.officeDetails.office.name}
                </div>
              </div>

              <div className="route clearfix">
                <div className="airport">
                  <span>
                    <IntlMessages id="travel.date" />
                  </span>
                  {moment(
                    reservation.officeDetails.date,
                    'DD/MM/YYYY HH:mm'
                  ).format('DD/MM')}
                </div>
                <div className="to text-center">
                  <img
                    src="/assets/img/icons/office_white.svg"
                    alt={messages['alts.components.timeline.office-card']}
                  />
                </div>
                <div className="airport text-right">
                  <span>
                    <IntlMessages id="travel.room_size" />
                  </span>
                  {reservation.officeDetails.selectedRoom.size}
                </div>
              </div>
            </div>
          </div>

          <AlertCard order={order} />
        </div>
      </div>
    );
  }
}

export default injectIntl(OfficeCard);
